<template>
	<modal titulo="Informe o motivo">

    <card>

      <div class="row">
        <v-input type="textarea" :error="validation.motivo"
                 v-model="form.motivo" class="col-12" />
      </div>

    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-2">Cancelar</button>
      <v-button :run="run" :popover="true" class="btn-outline-primary">Informar Erro</v-button>
    </template>

  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import DominioBusiness from "@/business/protocolo/DominioBusiness.js";
import ProtocoloBusiness from "@/business/protocolo/ProtocoloBusiness.js";
import ProtocoloProcessoBusiness from "@/business/protocolo/ProtocoloProcessoBusiness.js";
import Card from "@/components/Layout/components/Card.vue";
import Modal from "@/components/Modal";
import TextExtractorBusiness from "@/views/Odin/componentes/TextExtractorBusiness";

export default {
    name: "ModalJustificarInformacaoErro",
    components: {Card, Modal},
    props: {
      tipo : String,
      referencia : String
    },
    data() {
      return {
        form: {
          motivo : '',
        },
        validation: {}
      }
    },

    methods:{

      close() {
        FrontBusiness.closeModal();
      },

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '#formulario-cadastro-protocolo');
      },

      async run() {
        this.$set(this, 'validation', {});

        const r = await TextExtractorBusiness.setError(this.tipo, this.referencia, this.form.motivo)
          .catch(e => { FrontBusiness.showError('', e.message); return false})

        if(r){
          this.close();
          FrontBusiness.showSuccess('', 'Agradecemos o feedback.')
        }

      },
    }
  }
</script>

<style lang=scss>

</style>
